/**
 * Strings only the web console has — the shell, navigation and sign-in states that the Flutter
 * owner module has no screen for. Anything the Flutter app also says lives in the ported tables
 * (`owner-strings.ts`, `staff-ops-strings.ts`, `shared-strings.ts`).
 */
import { l10nTable } from './l10n';

export const webStrings = l10nTable(
    {
        // shell
        'appName': 'InnPro Resto',
        'ownerConsole': 'Owner console',
        'outlet': 'Outlet',
        'more': 'More',
        'language': 'Language · భాష',
        'lightMode': 'Light mode',
        'darkMode': 'Dark mode',
        'light': 'Light',
        'dark': 'Dark',
        'loading': 'Loading…',
        'close': 'Close',
        'refresh': 'Refresh',
        'apply': 'Apply',
        'customRange': 'Custom range',
        'selectOutletBody': 'Your account can see more than one outlet. Pick the one to manage.',
        // navigation
        'navDashboard': 'Dashboard',
        'navMenuShort': 'Menu',
        'navHubUpload': 'Upload hub file',
        'navOutlet': 'Outlet profile',
        'navTax': 'Tax · GST',
        'subSales': 'net sales, discounts, voids',
        'subItems': 'this vs previous period',
        'subProfit': 'P&L and item margins',
        'subKot': 'per station, slowest hours',
        'subTables': 'turns, seated time',
        'subStaff': 'per captain, discounts & voids',
        'subWaste': 'prepared vs sold',
        'subPay': 'by mode and cashier',
        'subRoom': 'posted to folios',
        // sync bar
        'syncUnavailable': 'Hub sync status unavailable',
        'syncChecking': 'checking hub sync…',
        'syncNever': 'the hub has not synced yet',
        'syncPending': ' · changes pending at hub',
        'syncing': 'Syncing…',
        // sign-in states
        'noOutletBody':
            'Your InnPro account has no restaurant outlet yet. Ask InnPro support to attach your outlet, then sign in again.',
        'notOwnerTitle': 'This account cannot open the owner console',
        'notOwnerBody':
            'Cloud sign-in is only for outlet owners and InnPro admins. Waiters, cashiers, kitchen and manager logins work on the restaurant hub with a user code and PIN.',
        'notOwnerHint': 'If you are the owner, make sure your InnPro account uses the same e-mail address as this login.',
        'startupTitle': 'Could not start the console',
        'startupBody': 'Something went wrong while loading your account.',
        'tryAgain': 'Try again',
        // errors raised in the browser (resto-api's own messages are shown as sent)
        'errOffline': 'Could not reach the server — check your connection',
        'errSession': 'Your session has expired',
        'errNetwork': 'Network error',
        'errReadFile': 'Could not read the file',
        // small labels
        'stagedNextDay': 'Staged · next day',
        'veg': 'Veg',
        'nonVeg': 'Non-veg',
        'egg': 'Egg',
    },
    {
        'ownerConsole': 'యజమాని కన్సోల్',
        'outlet': 'అవుట్‌లెట్',
        'more': 'మరిన్ని',
        'lightMode': 'లైట్ మోడ్',
        'darkMode': 'డార్క్ మోడ్',
        'light': 'లైట్',
        'dark': 'డార్క్',
        'loading': 'వస్తోంది…',
        'close': 'మూసేయండి',
        'refresh': 'మళ్లీ తీసుకురండి',
        'apply': 'సరే',
        'customRange': 'తేదీలు ఎంచుకోండి',
        'selectOutletBody': 'మీ ఖాతాలో ఒకటి కంటే ఎక్కువ అవుట్‌లెట్‌లు ఉన్నాయి. చూడాల్సింది ఎంచుకోండి.',
        'navDashboard': 'డాష్‌బోర్డ్',
        'navMenuShort': 'మెనూ',
        'navHubUpload': 'హబ్ ఫైల్ అప్‌లోడ్',
        'navOutlet': 'అవుట్‌లెట్ వివరాలు',
        'navTax': 'పన్ను · GST',
        'subSales': 'నికర అమ్మకాలు, డిస్కౌంట్లు, రద్దులు',
        'subItems': 'ఈ రోజులు, ముందు రోజులు పోల్చి',
        'subProfit': 'లాభ నష్టాలు, వస్తువుల మార్జిన్',
        'subKot': 'స్టేషన్ వారీగా, ఆలస్యమైన గంటలు',
        'subTables': 'ఎన్నిసార్లు నిండాయి, కూర్చున్న సమయం',
        'subStaff': 'కెప్టెన్ వారీగా, డిస్కౌంట్లు, రద్దులు',
        'subWaste': 'వండినవి, అమ్మినవి',
        'subPay': 'చెల్లింపు పద్ధతి, క్యాషియర్ వారీగా',
        'subRoom': 'రూమ్ బిల్లులో కలిపినవి',
        'syncUnavailable': 'హబ్ సింక్ వివరాలు తెలియడం లేదు',
        'syncChecking': 'హబ్ సింక్ చూస్తున్నాం…',
        'syncNever': 'హబ్ ఇంకా సింక్ కాలేదు',
        'syncPending': ' · హబ్‌లో మార్పులు వేచి ఉన్నాయి',
        'syncing': 'సింక్ అవుతోంది…',
        'noOutletBody':
            'మీ InnPro ఖాతాకు ఇంకా రెస్టారెంట్ అవుట్‌లెట్ కలపలేదు. InnPro సపోర్ట్‌ని అడిగి కలిపించుకుని, మళ్లీ సైన్ ఇన్ అవ్వండి.',
        'notOwnerTitle': 'ఈ ఖాతాతో యజమాని కన్సోల్ తెరవలేరు',
        'notOwnerBody':
            'క్లౌడ్ సైన్ ఇన్ అవుట్‌లెట్ యజమానులకు, InnPro అడ్మిన్‌లకు మాత్రమే. వెయిటర్, క్యాషియర్, కిచెన్, మేనేజర్ లాగిన్‌లు రెస్టారెంట్ హబ్‌లో యూజర్ కోడ్, PINతో పని చేస్తాయి.',
        'notOwnerHint': 'మీరే యజమాని అయితే, మీ InnPro ఖాతాలో ఇదే ఈమెయిల్ ఉందో లేదో చూడండి.',
        'startupTitle': 'కన్సోల్ తెరవలేకపోయాం',
        'startupBody': 'మీ ఖాతా వివరాలు తీసుకురావడంలో ఏదో తప్పు జరిగింది.',
        'tryAgain': 'మళ్లీ ప్రయత్నించండి',
        'errOffline': 'సర్వర్ అందడం లేదు — ఇంటర్నెట్ చూడండి',
        'errSession': 'మీ సెషన్ ముగిసింది',
        'errNetwork': 'నెట్‌వర్క్ సమస్య',
        'errReadFile': 'ఫైల్ చదవలేకపోయాం',
        'stagedNextDay': 'వేచి ఉంది · తర్వాతి రోజు',
        'veg': 'వెజ్',
        'nonVeg': 'నాన్-వెజ్',
        'egg': 'గుడ్డు',
    },
);
